import { render, staticRenderFns } from "./frequency.vue?vue&type=template&id=4c39e97c&"
import script from "./frequency.vue?vue&type=script&lang=js&"
export * from "./frequency.vue?vue&type=script&lang=js&"
import style0 from "./frequency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "frequency.vue"
export default component.exports